import type { ReactNode } from 'react'

import styles from './PageFade.module.css'

/**
 * Wrapper de rotas — dispara fade-in tier-aware no mount.
 *
 * Aplicado em routes.tsx via withSuspense/withAuth. Em vlow/low o token
 * `--page-transition-duration` é 0ms, então a animação é no-op (mount
 * duro como antes da Onda 1 de polish — zero regressão).
 *
 * Por que CSS-only e não framer-motion:
 * - Bundle: 0 bytes adicionais (vs ~40KB do framer-motion).
 * - Composite-only: só opacity, GPU paint zero.
 * - Norigin spatial nav não conflita — focusKey registra no useEffect
 *   do <Focusable>, independente da animação CSS.
 */
export function PageFade({ children }: { children: ReactNode }) {
  return <div className={styles.root}>{children}</div>
}
